<div class="modal-header">
  <h4 class="modal-title">
    {{ taskActionOptions.titleText }}
  </h4>
  <aurora-icon-button class="close" type="button" (click)="cancel()" icon="times" size="large"></aurora-icon-button>
</div>
<div class="modal-body">
  <dataservice-error></dataservice-error>
  <ng-container *ngIf="_taskActionMode != 'EditProject'">
    <div style="margin: 0px">
      <ep-task-action-edit-panel
        [taskActionMode]="_taskActionMode"
        [taskActionOptions]="taskActionOptions"
      ></ep-task-action-edit-panel>
    </div>
  </ng-container>
  <ng-container *ngIf="_taskActionMode == 'EditProject'">
    <div style="margin: 0px">
      <ep-task-action-edit-panel
        [taskActionMode]="_taskActionMode"
        [taskActionOptions]="taskActionOptions"
      ></ep-task-action-edit-panel>
    </div>
  </ng-container>
</div>
<div class="modal-footer">
  <aurora-button type="button" (click)="actionTaken()" variant="primary">
    {{ taskActionOptions.buttonText }}
  </aurora-button>
  <aurora-button type="button" (click)="cancel()" variant="ghost">Cancel</aurora-button>
</div>
